import React from 'react';
import { ScrollView, StyleSheet, Text, View } from 'react-native';

export default function PrivacyScreen() {
  const privacySections = [
    {
      title: '信息收集',
      content: [
        '为了提供更好的服务，我们可能会收集以下信息：',
        '• 设备信息：设备型号、操作系统版本',
        '• 账户信息：手机号、昵称、头像',
        '• 使用数据：消息记录、通话记录',
        '• 位置信息：仅在您授权的情况下获取',
      ],
    },
    {
      title: '信息使用',
      content: [
        '我们使用收集的信息用于：',
        '• 提供和维护服务',
        '• 改进用户体验',
        '• 发送重要通知',
        '• 防止欺诈和滥用',
        '• 遵守法律法规要求',
      ],
    },
    {
      title: '信息共享',
      content: [
        '我们承诺：',
        '• 不会向第三方出售您的个人信息',
        '• 仅在必要情况下与合作伙伴共享信息',
        '• 共享信息时采用加密传输',
        '• 您有权要求删除个人信息',
      ],
    },
    {
      title: '数据安全',
      content: [
        '我们采取以下措施保护您的信息安全：',
        '• 使用SSL加密传输',
        '• 定期进行安全审计',
        '• 限制员工访问权限',
        '• 建立安全事件响应机制',
      ],
    },
    {
      title: '您的权利',
      content: [
        '根据相关法律法规，您享有以下权利：',
        '• 访问您的个人信息',
        '• 更正不准确的个人信息',
        '• 删除个人信息',
        '• 撤销同意',
        '• 投诉和举报',
      ],
    },
    {
      title: '未成年人保护',
      content: [
        '我们特别关注未成年人的隐私保护：',
        '• 不主动收集未成年人信息',
        '• 家长可管理未成年人的账户',
        '• 不向未成年人推送不适宜内容',
        '• 提供家长控制功能',
      ],
    },
    {
      title: '协议更新',
      content: [
        '我们可能会不时更新本隐私协议：',
        '• 重大变更会通过通知告知',
        '• 继续使用即表示接受更新',
        '• 您有权随时停止使用服务',
      ],
    },
  ];

  return (
    <ScrollView style={styles.container}>
      <View style={styles.header}>
        <Text style={styles.title}>隐私协议</Text>
        <Text style={styles.subtitle}>最后更新：2024年3月1日</Text>
      </View>

      {privacySections.map((section, index) => (
        <View key={index} style={styles.section}>
          <Text style={styles.sectionTitle}>{section.title}</Text>
          {section.content.map((paragraph, pIndex) => (
            <Text key={pIndex} style={styles.content}>
              {paragraph}
            </Text>
          ))}
        </View>
      ))}

      <View style={styles.footer}>
        <Text style={styles.contactText}>如有疑问，请联系我们：</Text>
        <Text style={styles.contactEmail}>privacy@example.com</Text>
      </View>
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  contactEmail: {
    color: '#c9a227',
    fontSize: 16,
    fontWeight: 'bold',
  },
  contactText: {
    color: '#666',
    fontSize: 14,
    marginBottom: 8,
  },
  container: {
    backgroundColor: '#f5f5f5',
    flex: 1,
  },
  content: {
    color: '#666',
    fontSize: 15,
    lineHeight: 24,
    marginBottom: 8,
  },
  footer: {
    alignItems: 'center',
    backgroundColor: '#fff',
    marginTop: 12,
    paddingHorizontal: 16,
    paddingVertical: 20,
  },
  header: {
    backgroundColor: '#fff',
    paddingHorizontal: 16,
    paddingVertical: 24,
  },
  section: {
    backgroundColor: '#fff',
    marginTop: 12,
    paddingHorizontal: 16,
    paddingVertical: 20,
  },
  sectionTitle: {
    color: '#333',
    fontSize: 18,
    fontWeight: 'bold',
    marginBottom: 12,
  },
  subtitle: {
    color: '#999',
    fontSize: 14,
  },
  title: {
    color: '#333',
    fontSize: 24,
    fontWeight: 'bold',
    marginBottom: 8,
  },
});
